import {createAction, props} from '@ngrx/store';
import {IStates} from '../models/IStatesModel';
import {ICountyModel} from '../models/ICountyModel';
import {IYear} from '../models/IYearModel';

export enum CountyActionTypes {
  RETRIEVE_COUNTIES = '[ICounty] RetrieveCounties',
  COUNTIES_RECEIVED = '[ICounty] CountiesReceived'
}

export const RetrieveCountiesAction = createAction(
  CountyActionTypes.RETRIEVE_COUNTIES,
  props<{ state: IStates; year: IYear }>()
);

export const CountiesReceivedAction = createAction(
  CountyActionTypes.COUNTIES_RECEIVED,
  props<{ counties: Array<ICountyModel> }>()
);
